"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _QuantityField = _interopRequireDefault(require("@sprinx/react-shopping-cart/QuantityField"));

var _ButtonAddToCart = _interopRequireDefault(require("@sprinx/react-shopping-cart/ButtonAddToCart"));

var _ref3 = /*#__PURE__*/_react.default.createElement("div", null, "hoo");

function AddToCartButtonToQty(_ref) {
  var ButtonAddToCartProps = _ref.ButtonAddToCartProps,
      onAddToCart = _ref.onAddToCart,
      quantity = _ref.quantity,
      QuantityFieldProps = _ref.QuantityFieldProps,
      quantityMax = _ref.quantityMax,
      quantityMin = _ref.quantityMin,
      quantityStep = _ref.quantityStep,
      quantityStepRounding = _ref.quantityStepRounding;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isDisabled = _useState2[0],
      setDisabled = _useState2[1];

  var handleButtonClick = _react.default.useCallback( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setDisabled(true);
            _context.next = 3;
            return onAddToCart(quantityMin);

          case 3:
            setDisabled(false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [onAddToCart, quantityMin]);

  return quantity > 0 ? /*#__PURE__*/_react.default.createElement(_QuantityField.default, (0, _extends2.default)({
    quantity: quantity,
    quantityMax: quantityMax,
    quantityMin: quantityMin,
    quantityStep: quantityStep,
    quantityStepRounding: quantityStepRounding,
    onChange: onAddToCart
  }, QuantityFieldProps)) : _ref3 && /*#__PURE__*/_react.default.createElement(_ButtonAddToCart.default, (0, _extends2.default)({
    disabled: isDisabled,
    onClick: handleButtonClick
  }, ButtonAddToCartProps));
}

process.env.NODE_ENV !== "production" ? AddToCartButtonToQty.propTypes = {
  /**
   * all specific props sending to `ButtonAddToCartProps`
   * options: { className, classes, color, variant, size }
   */
  ButtonAddToCartProps: _propTypes.default.shape({}),
  classes: _propTypes.default.shape({
    addToCartButton: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onAddToCart: _propTypes.default.func,
  quantity: _propTypes.default.number,

  /**
   * all specific props sending to `QuantityField`
   * options: { leftAdornment, rightAdornment, className, classes, size, etc... }
   * You can also overwrite any other props
   */
  QuantityFieldProps: _propTypes.default.shape({}),
  quantityMax: _propTypes.default.number,
  quantityMin: _propTypes.default.number,
  quantityStep: _propTypes.default.number,
  quantityStepRounding: _propTypes.default.oneOf(['up', 'down'])
} : void 0;
AddToCartButtonToQty.defaultProps = {
  ButtonAddToCartProps: undefined,
  classes: undefined,
  className: undefined,
  disabled: false,
  onAddToCart: undefined,
  quantity: undefined,
  QuantityFieldProps: undefined,
  quantityMax: undefined,
  quantityMin: 1,
  quantityStep: 1,
  quantityStepRounding: undefined
};
var _default = AddToCartButtonToQty;
exports.default = _default;